/* Diffuser guides (sections/ap-diffuser-guide.liquid): one card per screen.
 * Each card is its own URL (?type=w|h&s=<n>); Back, reload and shared links land on it.
 * The card after the last one is the "what next" screen. */
(() => {
  const root = document.querySelector('[data-apdg]');
  if (!root) return;
  const CFG = JSON.parse(root.querySelector('[data-apdg-config]').textContent);
  // Deck copy comes from assets/ap-dh-guides.js (audited source: docs/research/diffuser-help/flows/guides-copy.json).
  CFG.decks = (window.APDH_GUIDES || {})[CFG.guide] || {};
  if (!Object.keys(CFG.decks).length) return;
  const panel = root.querySelector('[data-apdg-panel]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const types = Object.keys(CFG.decks);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const icon = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
  const I = { next: 'M9 6l6 6-6 6', back: 'M15 6l-6 6 6 6', mist: 'M8 20c0-3 2-3 2-6s-2-3-2-6M12 20c0-3 2-3 2-6s-2-3-2-6M16 20c0-3 2-3 2-6s-2-3-2-6',
    power: 'M12 3v9M7.5 6.2a7 7 0 1 0 9 0', drop: 'M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z', weak: 'M4 15h3M9 12h3M14 9h3M19 6h1' };
  // Site-wide tracker (snippets/ap-track.liquid) -> GA4 + dashboard. Flat props only, no PII.
  const track = (event, data = {}) => {
    const p = { guide: CFG.guide }; Object.entries(data || {}).forEach(([k, v]) => { if (Array.isArray(v)) p[k] = v.join(','); else if (v == null || typeof v !== 'object') p[k] = v; });
    if (typeof window.apTrack === 'function') window.apTrack(`diffuser_guide_${event}`, p, 'diffuser_help');
  };

  const state = { type: types[0], s: 0 };
  function read() {
    const q = new URLSearchParams(location.search);
    state.type = types.includes(q.get('type')) ? q.get('type') : types[0];
    state.s = Math.min(Math.max(0, Number(q.get('s') || 0) || 0), CFG.decks[state.type].length);
  }
  const urlFor = (type, s) => {
    const q = new URLSearchParams();
    if (types.length > 1) q.set('type', type);
    if (s) q.set('s', String(s));
    const qs = q.toString();
    return location.pathname + (qs ? `?${qs}` : '');
  };
  let pushed = 0;
  function go(type, s) {
    try { history.pushState({ apdg: true }, '', urlFor(type, s)); pushed += 1; } catch (e) { location.href = urlFor(type, s); return; }
    read(); render(true);
  }
  window.addEventListener('popstate', () => { if (pushed > 0) pushed -= 1; read(); render(true); });

  const media = (card) => {
    if (!card.product && CFG.products[card.img]) card = { ...card, product: card.img };
    if (card.product) return CFG.products[card.product] ? `<figure class="apdh-step__media apdh-step__media--product"><img src="${esc(CFG.products[card.product])}" alt="" width="900" height="900"></figure>` : '';
    const s = CFG.art.s.replace('ART', card.img); const l = CFG.art.l.replace('ART', card.img);
    return `<figure class="apdh-step__media"><img src="${esc(l)}" srcset="${esc(s)} 480w, ${esc(l)} 900w" sizes="(max-width: 749px) 300px, 420px" width="900" height="900" alt=""></figure>`;
  };

  function viewCard() {
    const deck = CFG.decks[state.type];
    const card = deck[state.s];
    const n = state.s + 1;
    const seg = types.length > 1 ? `<div class="apdh-seg apdg-seg" role="radiogroup" aria-label="Diffuser type">
        <button type="button" role="radio" aria-checked="${state.type === 'w'}" data-type="w">Waterless <small>Uses oil, no water</small></button>
        <button type="button" role="radio" aria-checked="${state.type === 'h'}" data-type="h">Humidifying <small>Uses water + oil</small></button></div>` : '';
    return `
      <div class="apdh-bar"><p class="apdh-bar__ctx"><span>Help desk</span><span class="is-now">${esc(CFG.title)}</span></p><span class="apdh-bar__count">${n}/${deck.length}</span></div>
      <div class="apdh-meter" aria-hidden="true"><span style="width:${(n / deck.length) * 100}%"></span></div>
      ${seg}
      <article class="apdh-step" data-swipe>${media(card)}<div class="apdh-step__body">
        <p class="apdh-step__kicker">${esc(card.when)}</p><h2 class="apdh-h2" tabindex="-1" data-focus>${esc(card.title)}</h2>
        <ol class="apdh-list">${card.body.map((b) => `<li>${esc(b)}</li>`).join('')}</ol>
        ${card.link ? `<a class="apdh-link" href="${esc(card.link.href)}">${esc(card.link.label)} ${icon(I.next)}</a>` : ''}
        <div class="apdh-verdict apdh-verdict--use">
          <button type="button" class="apdh-btn apdh-btn--wine" data-next>${n < deck.length ? 'Next' : 'Done'} ${icon(I.next)}</button>
        </div>
        <div class="apdg-dots" aria-hidden="true">${deck.map((_, i) => `<span class="${i === state.s ? 'is-on' : ''}"></span>`).join('')}</div>
      </div></article>`;
  }

  function viewEnd() {
    const other = CFG.guide === 'tips'
      ? `<a class="apdh-done__card" href="/pages/diffuser-care">${icon(I.drop)}<span><strong>Care &amp; cleaning guide</strong><small>Four quick habits</small></span>${icon(I.next)}</a>`
      : `<a class="apdh-done__card" href="/pages/diffuser-tips">${icon(I.weak)}<span><strong>Get more scent</strong><small>Placement, strength and timing</small></span>${icon(I.next)}</a>`;
    return `
      <div class="apdh-bar"><p class="apdh-bar__ctx"><span>Help desk</span><span class="is-now">${esc(CFG.title)}</span></p></div>
      <article class="apdh-done">
        <span class="apdh-done__seal" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>
        <h2 class="apdh-h2" tabindex="-1" data-focus>${CFG.guide === 'tips' ? 'That\'s the secret.' : 'That\'s the whole routine.'} <em>Easy, right?</em></h2>
        <p class="apdh-lead">Anything else we can help with?</p>
        <div class="apdh-done__cards">
          <a class="apdh-done__card" href="${CFG.help}">${icon(I.mist)}<span><strong>Something's not right</strong><small>Tell us what's happening</small></span>${icon(I.next)}</a>
          <a class="apdh-done__card" href="${CFG.howto}">${icon(I.power)}<span><strong>How to use it</strong><small>Step-by-step for your model</small></span>${icon(I.next)}</a>
          ${other}
        </div>
      </article>`;
  }

  function render(focus) {
    const end = state.s >= CFG.decks[state.type].length;
    panel.innerHTML = end ? viewEnd() : viewCard();
    if (!reduceMotion) { panel.classList.remove('is-in'); void panel.offsetWidth; panel.classList.add('is-in'); }
    document.title = `${CFG.title} | ${CFG.shop}`;
    window.APIM?.sync?.({ back: true, restart: true });
    root.classList.add('is-ready');
    if (focus) {
      panel.querySelector('[data-focus]')?.focus({ preventScroll: true });
      if (window.scrollY > 0) window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  const back = () => (pushed > 0 ? history.back() : go(state.type, Math.max(0, state.s - 1)));
  panel.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t) return;
    if (t.matches('[data-next]')) { if (state.s + 1 >= CFG.decks[state.type].length) track('complete', { type: state.type }); return go(state.type, state.s + 1); }
    if (t.matches('[data-prev]')) return back();
    if (t.matches('[data-type]') && t.dataset.type !== state.type) { track('type', { type: t.dataset.type }); return go(t.dataset.type, 0); }
  });
  // Swipe between cards on touch screens.
  let x0 = null;
  panel.addEventListener('touchstart', (e) => { if (e.target.closest('[data-swipe]')) x0 = e.touches[0].clientX; }, { passive: true });
  panel.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) < 60) return;
    if (dx < 0) go(state.type, state.s + 1); else if (state.s > 0) back();
  }, { passive: true });
  document.addEventListener('keydown', (e) => {
    if (e.target.closest('input, textarea')) return;
    if (e.key === 'ArrowRight') go(state.type, Math.min(state.s + 1, CFG.decks[state.type].length));
    if (e.key === 'ArrowLeft' && state.s > 0) back();
  });

  // Header back: previous card; from the first card, the page they came from (e.g. the diagnostic's
  // "while you wait" link), else the diagnostic. Start over = the diagnostic (header link default).
  const cameFromSite = (() => { try { return new URL(document.referrer).origin === location.origin; } catch (e) { return false; } })();
  window.APIM = Object.assign(window.APIM || {}, { back: () => (state.s > 0 ? back() : (cameFromSite && history.length > 1 ? history.back() : (location.href = CFG.help))) });

  read();
  render(false);
  track('view', { type: state.type, s: state.s });
})();
